import React from 'react';
import * as d3 from 'd3';
import PropTypes from 'prop-types';
import './custom-lline-graph.css';
import { utils } from '../../config';

export class CustomLineGraph extends React.Component {
    constructor(props) {
        super(props);
        this.myRef = React.createRef();
        this.comId = (Math.random() * 1000000<<0).toString(16);
        this.timer = null;
        this.container = null;
        this.state = {
            data: this.props.data,
            langSwitch: this.props.langSwitch
        };
        this.width = this.props.width || 600;
        this.height = this.props.height || 400;
        this.initChart = this.initChart.bind(this);
        this.refreshChart = this.refreshChart.bind(this);
    }

    componentDidMount() {
        this.container = this.myRef.current;
        this.width = this.myRef.current.clientWidth - 20;
        window.addEventListener('resize', this.refreshChart, false);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.refreshChart, false);
    }

    refreshChart = () => {
        this.timer = setTimeout(() => {
            if (this.timer) {
                clearTimeout(this.timer);
            }

            // Temp fix. Willunmount lifecycle is not called on route change
            // React Router has some issue.
            if (typeof this.myRef === 'undefined' || !this.myRef.current.clientWidth) {
                return;
            }

            this.width = this.myRef.current.clientWidth - 20;
            this.initChart();    
        }, 100);
        
    }

    componentWillReceiveProps(newProps) {
        var shouldUpdate = false;
        var obj = {};
        if (this.state.data !== newProps.data) {
            obj.data = newProps.data;
            shouldUpdate = true;
        }
        if (this.state.highlightPoint !== newProps.highlightPoint) {
            obj.highlightPoint = newProps.highlightPoint
            shouldUpdate = true;
        }

        if (newProps.reload !== this.props.reload) {
            obj.reload = newProps.reload;
            shouldUpdate = true;
        }
        
        if (shouldUpdate) {
            this.setState(obj, function() {
                this.refreshChart();
            });
        }
        if (this.state.langSwitch !== newProps.langSwitch) {
            this.setState({
                langSwitch: newProps.langSwitch
            });
            this.refreshChart();
        }
        
    }

    initChart() {
        var svg = d3.select('.visualisation-line-'+this.comId);
        var margin = { top: 20, right: 20, bottom: 30, left: 40 };
        var data = this.state.data;
        var width, height;
        width = this.width - margin.left - margin.right;
        height = this.height - margin.top - margin.bottom;


        svg.attr("width", this.width)
            .attr("height", this.height);

        svg.selectAll('*').remove();
            
        var x = d3.scaleLinear()
            .rangeRound([0, width ]);

        var y = d3.scaleLinear()
            .rangeRound([height, 0]);

        x.domain(d3.extent(data, function(d) { return d.time })).nice(6);
        y.domain(d3.extent(data, function(d) { return d.value })).nice(6);


        var g = svg.append("g")
            .attr("transform", "translate(" + margin.left + "," + margin.top + ")")
            .attr("class", "grid")
            .call(d3.axisLeft(y)
                .ticks(5)
                .tickSize(-width,0,0)
                .tickFormat("")
            );

        
        var line = d3.line()
            .curve(d3.curveCardinal)
            .x(function(d) { return x(d.time)})
            .y(function(d) { return y(d.value)});

        g.append("g")
            .attr("transform", "translate(0," + height + ")")  
            .attr("class", "grid")  
            .call(d3.axisBottom(x)
                .ticks(6)
                .tickSize(-height,0,0)
                .tickFormat("")
            )  
       
        g.append("g")
            .attr("transform", "translate(0," + height + ")")
            .call(
                d3.axisBottom(x)
                .ticks(6)
            )
            .append("text")
            .attr("fill", "#000")
            .attr("y", -7)
            .attr("x", width)
            .attr("dx", '-1em')
            .text(utils.getTranslationText('lbl_time','Time'));

        g.append("g")
            .call(
                d3.axisLeft(y)
                    .ticks(5)
            )
            .append("text")
            .attr("fill", "#000")
            .attr("transform", "rotate(-90)")
            .attr("y", 6)
            .attr("dy", "0.71em")
            .attr("text-anchor", "end")
            .text(utils.getTranslationText('lbl_firmness', 'Firmness') + ' (%)'); 
        
    

        g.append("path")
            .datum(data)
            .attr("fill", "none")
            .attr("stroke", "steelblue")
            .attr("stroke-linejoin", "round")
            .attr("stroke-linecap", "round")
            .attr("stroke-width", 3)
            .attr("d", line);

    
            if (this.state.highlightPoint && this.state.highlightPoint.time > 0) {
                let dotNew = g.selectAll('.dot-new')
                    .data([this.state.highlightPoint])
                    .enter()
                    .append('g');


                dotNew.append("circle")
                    .attr("stroke", "#fff")
                    .attr("fill", "#f00")
                    .attr("cx", function(d) { return x(d.time) })
                    .attr("cy", function(d) { return y(d.value) })
                    .attr("r", 8)

                dotNew.append("rect")
                    .attr("fill", "#fff")
                    .attr("x", function(d) { return x(d.time) - 5 })
                    .attr("y", function(d) { return y(d.value) + 8 })
                    .attr("width", 45)
                    .attr("height", 20);
               
                dotNew.append("text")
                        .attr("fill", "#f00")
                        .attr("stroke", "#fff")
                        .attr("stroke-width", "0.25")
                        .attr("x", function(d) { return x(d.time)  })
                        .attr("y", function(d) { return y(d.value) })
                        .attr("font-size", "13px")
                        .attr("font-weight", "700")
                        .attr("dy", 22)
                        .attr("dx", 16)
                        .attr("text-anchor", "middle")
                        .text(function(d) {
                            return parseFloat(d.value).toFixed(2)+'%';
                        }); 
            }
    }

    render() {
        return <div className="vis" ref={this.myRef}>
                <svg 
                    className={'visualisation-line-'+this.comId} 
                    width="300"
                    height="400">
                </svg>
        </div>;
    }
}

CustomLineGraph.propTypes = {
    data: PropTypes.array,
    width: PropTypes.number,
    height: PropTypes.number,
    assignClass: PropTypes.string,
    highlightPoint: PropTypes.object,
    reload: PropTypes.bool,
    langSwitch: PropTypes.bool
};


// WEBPACK FOOTER //
// ./src/components/custom-line-graph/index.js